import React, { Component } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, ActivityIndicator} from "react-native-web";

import HamburgerMenu from 'react-hamburger-menu';

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function FooterTablet() {
  const currentYear = new Date().getFullYear();
   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;






    return (

      <div style={{backgroundColor: 'transparent'}}>

         <div style={{height: '100px'}}/>


         {i18n.language == 'en' &&
            <div style={{width: '94%', margin: 'auto', fontSize: '16px', fontFamily: 'Roboto', paddingTop: '20px', textAlign: 'center', borderTop: '1px solid #ccc'}}>
                © {currentYear} · StorryPage, a product of <a href="https://www.debyoo.com" target="_blank">Debyoo</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/about">{i18n.t('About')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/get-a-storrypage">{i18n.t('Get_a_storrypage')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/living-memory-of-congo">{i18n.t('Living_memory_of_congo')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/help">{i18n.t('Help_center')}</a>
           </div>
         }

         {i18n.language == 'fr' &&
            <div style={{width: '94%', margin: 'auto', fontSize: '16px', fontFamily: 'Roboto', paddingTop: '20px', textAlign: 'center', borderTop: '1px solid #ccc'}}>
                © {currentYear} · StorryPage, un produit de <a href="https://www.debyoo.com" target="_blank">Debyoo</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/about">{i18n.t('About')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/get-a-storrypage">{i18n.t('Get_a_storrypage')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/memoire-vivante-du-congo">{i18n.t('Living_memory_of_congo')}</a>&nbsp;&nbsp;·&nbsp;&nbsp;<a href="/help">{i18n.t('Help_center')}</a>
           </div>
         }

         <div style={{height: '30px'}}/>

      </div>

    )

}
